var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2137 6.02204C15.5554 5.68033 15.5554 5.12631 15.2137 4.7846C14.872 4.44289 14.318 4.44289 13.9762 4.7846L9.99865 8.76219L6.02106 4.7846C5.67935 4.44289 5.12533 4.44289 4.78363 4.7846C4.44192 5.12631 4.44192 5.68033 4.78363 6.02204L8.76122 9.99963L4.78386 13.977C4.44215 14.3187 4.44215 14.8727 4.78386 15.2144C5.12557 15.5561 5.67959 15.5561 6.02129 15.2144L9.99865 11.2371L13.976 15.2144C14.3177 15.5561 14.8717 15.5561 15.2135 15.2144C15.5552 14.8727 15.5552 14.3187 15.2135 13.977L11.2361 9.99963L15.2137 6.02204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteExit);
export default __webpack_public_path__ + "static/media/WhiteExit.4975fbae2ca6d1320936560e94e10d8e.svg";
export { ForwardRef as ReactComponent };